import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { Directions, EditOutlined } from "@mui/icons-material";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import LocalTransportRuleBasicDetail from "./LocalTransportRuleComponents/LocalTransportRuleBasicDetail";
import LocalTransportRuleDetailTab from "./LocalTransportRuleComponents/LocalTransportRuleDetailTab";
import {
  LocalTransportRuleDetailContext,
  useLocalTransportRuleDetailContext,
} from "contexts/LocalTransportRuleDetailContext";
import { useAuth } from "hooks";
import { useGetLocalTransportRuleDetailQuery, useToggleBidirectionalRuleMutation } from "store/services/LocalTransportRuleApi";
import { toast } from "react-toastify";

const LocalTransportRuleDetailScreen = () => {
  const { id } = useParams();

  const {
    data: ruleDetail,
    isLoading: loadingRule,
    error,
  } = useGetLocalTransportRuleDetailQuery(id);

  const breadcrumbs = [
    {
      title: "Local Transport Rules",
      path: "/app/crm/local-transport-rule/list",
    },
    { title: "Rule Detail" },
  ];

  return (
    <LocalTransportRuleDetailContext.Provider
      value={{ ruleDetail, loadingRule }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingRule}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <LocalTransportRuleBasicDetail />
          <Divider />
          <LocalTransportRuleDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </LocalTransportRuleDetailContext.Provider>
  );
};

export default LocalTransportRuleDetailScreen;

const PageActions = () => {
  const { ruleDetail } = useLocalTransportRuleDetailContext();
  const { isAccountAdmin } = useAuth();
  const [toggleBidirectional, { isLoading }] =
    useToggleBidirectionalRuleMutation();

  const handleToggle = async () => {
    try {
      await toggleBidirectional(ruleDetail._id).unwrap();
      toast.success("Bidirectional rule updated");
    } catch (err) {
      toast.error(err?.data?.message || "Failed to update rule");
    }
  };
  return (
    <div className="flex items-center gap-4">
      {/* add toggle button when clicked then Bidirectional true or false */}
      {isAccountAdmin && (
        <Button
          startIcon={<Directions />}
          variant={ruleDetail?.isBidirectional ? "outlined" : "contained"}
          color={ruleDetail?.isBidirectional ? "success" : "primary"}
          onClick={handleToggle}
          disabled={isLoading}
        >
          {ruleDetail?.isBidirectional ? "Bidirectional ON" : "Bidirectional OFF"}
        </Button>
      )}
      <Link to={`/app/crm/local-transport-rule/${ruleDetail?._id}/edit`}>
        {isAccountAdmin && (
          <Button startIcon={<EditOutlined />} variant="contained">
            Edit Rule
          </Button>
        )}
      </Link>
    </div>
  );
};
